import { useAuthStore } from '~/stores/auth';
import { useBootstrapStore } from '~/stores/bootstrap';

export default defineNuxtRouteMiddleware((to, from) => {
   
  const authStore = useAuthStore();
  const bootstrapStore = useBootstrapStore();

  // Wait for bootstrap to complete before checking permissions
if (!bootstrapStore.loaded) {
  return  // Allow navigation, don't check permissions yet
}

  // Skip auth check on the pages you reach without a session
  if (to.path === '/login' || to.path === '/register') {
    return
  }

  // Redirect to login if not authenticated
  if (!authStore.isAuthenticated) {
    return navigateTo('/login');
  }
});
